import { render, staticRenderFns } from "./RichTextDisplay.vue?vue&type=template&id=3974ed9d&scoped=true&"
import script from "./RichTextDisplay.vue?vue&type=script&lang=ts&"
export * from "./RichTextDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./RichTextDisplay.vue?vue&type=style&index=0&id=3974ed9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3974ed9d",
  null
  
)

export default component.exports